import React, {
  useEffect,
  useRef,
  useState,
  lazy,
  Suspense,
} from "react";
import {
  FormControlLabel,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  makeStyles,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Radio,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import FlagIcon from "@material-ui/icons/Flag";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import { ChevronRight } from "@material-ui/icons";
import {
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import BackDropLoading from "../../models/BackDrop";
import { appUrl } from "../../../../../../utils/config";
// import AllocationQuantityForConsumption from "./AllocationQuantityForConsumption";

const AllocationQuantityForConsumption = lazy(() =>
  import("./AllocationQuantityForConsumption")
);

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    border: "2px solid #ccc",
    borderRadius: "8px",
    overflow: "auto",
    maxWidth: "99%",
  },
  commentField: {
    "& .MuiInputBase-input": {
      lineHeight: "1.2rem",
    },
  },

  headerCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    lineHeight: "2rem",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    // backgroundColor: '#fff',
    zIndex: 1,
  },
  customSelect: {
    minWidth: 150,
  },
  customRadio: {
    color: "#ec6535 !important", // Selected radio button color
  },
  customCheckbox: {
    color: "#ec6535 !important", // Checked checkbox color
  },
  customSelectSty: {
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  textField: {
    "& .MuiInputBase-root": {
      lineHeight: "0.6rem",
    },
  },
  tablepadding: {
    "& .MuiTableCell-root": {
      padding: "2px",
    },
  },
  secondTablepadding: {
    "& .MuiTableCell-root": {
      padding: "2px",
    },
  },
  updatedHeader: {
    // "& .MuiTableCell-root":{
    //   padding:"0px"
    // },
    fontWeight: 700,
    fontSize: 13.6,
  },
  updatedSubHeader: {
    fontSize: 13.6,
    padding: "0px",
  },
  updatedTableContainer: {
    border: "2px solid #ccc",
    borderRadius: "1px",
    overflow: "auto",
    maxWidth: "99%",
    maxHeight: 150,
  },
}));


const EditPlannedAllocatedQuantityDialog = ({
  lotData,
  onClose,
  poData,
  schrockenSLID,
  vendorMosymphonyID,
  handleClose,
  lotAllocationData,
  lotAllocationRes,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const AllocationRef = useRef();
  const [selectedLotData, setSelectedLotData] = useState(lotData);

  const [selectedMaterial, setSelectedMaterial] = useState(
    lotData?.componentAllocationDetails?.componentCode
  );

  // Enable Save button conditionally
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  // const [disableReasonCode, setDisableReasonCode] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [materialsData, setMaterialsData] = useState({});
  const [materailStates, setMaterailStates] = useState({});

  const [previousLotPresent, setPreviousLotPresent] = useState(false);

  const debounceRef = useRef(null);



  useEffect(() => {
    let previousLots = [];

    lotAllocationData.forEach((val, i) => {
      if (val?.lotNumberAllocationDetails.length > 0) {
        let result = val?.lotNumberAllocationDetails.every((lot) => {
          return !lot?.lotNumber && !lot?.plannedAllocatedQuantity;
        });
        previousLots.push({
          prevLot: !result,
        });
      } else {
        previousLots.push({
          prevLot: false,
        });
      }
    });
    let val = previousLots.some((val) => {
      return val.prevLot;
    });
    setPreviousLotPresent(val);
  }, [lotAllocationData]);

  useEffect(() => {
    setSelectedLotData(lotData);
    setSelectedMaterial(lotData?.componentAllocationDetails?.componentCode);
  }, [lotData]);

  // useEffect(() => {
  //   if (materialsData && typeof materialsData === 'object' && lotAllocationData && Array.isArray(lotAllocationData) && lotAllocationData.length > 0 && Object.keys(materialsData).length > 0 && lotAllocationData.length === Object.keys(materialsData).length) {
  //     let validate = []
  //     lotAllocationData.forEach(element => {
  //       if (materialsData[element?.componentAllocationDetails?.componentCode] && materialsData[element?.componentAllocationDetails?.componentCode]?.states) {
  //         validate.push(materialsData[element?.componentAllocationDetails?.componentCode]?.states.isSaveEnabled)
  //       }

  //     });
  //     if (validate.filter(val => val === true).length === lotAllocationData.length) {
  //       setIsSaveEnabled(true)
  //     }
  //   }

  // }, [materialsData]);

  useEffect(() => {
    if (
      !materialsData ||
      typeof materialsData !== "object" ||
      !Array.isArray(lotAllocationData) ||
      lotAllocationData.length === 0 ||
      Object.keys(materialsData).length === 0
    ) {
      return;
    }

    clearTimeout(debounceRef.current);

  

    if (previousLotPresent) {
      const isAllSaveEnabled = lotAllocationData.some(
        ({ componentAllocationDetails }) => {
          const componentCode = componentAllocationDetails?.componentCode;
          return materailStates[componentCode]?.states?.isSaveEnabled === true;
        }
      );

      if(isAllSaveEnabled !== isSaveEnabled){
        debounceRef.current = setTimeout(() => {
    setIsSaveEnabled(isAllSaveEnabled);
  }, 150);
      // setIsSaveEnabled(isAllSaveEnabled);
      }
    } else {
      if (Object.keys(materialsData).length !== lotAllocationData.length) {
        return;
      }
      const isAllSaveEnabled = lotAllocationData.every(
        ({ componentAllocationDetails }) => {
          const componentCode = componentAllocationDetails?.componentCode;
          return materailStates[componentCode]?.states?.isSaveEnabled === true;
        }
      );
      if(isAllSaveEnabled !== isSaveEnabled){
        debounceRef.current = setTimeout(() => {
    setIsSaveEnabled(isAllSaveEnabled);
  }, 150);
      // setIsSaveEnabled(isAllSaveEnabled);
      }
    }
  }, [materialsData, lotAllocationData]);

  const handleSave = () => {
    let componentAllocationDataList = [];

    lotAllocationData.forEach((component, index) => {
      if (
        materialsData[component?.componentAllocationDetails?.componentCode]
          ?.componentAllocationDataList &&
        Array.isArray(
          materialsData[component?.componentAllocationDetails?.componentCode]
            .componentAllocationDataList
        ) &&
        materialsData[component?.componentAllocationDetails?.componentCode]
          .componentAllocationDataList.length > 0
      ) {
        componentAllocationDataList.push(
          materialsData[component?.componentAllocationDetails?.componentCode]
            .componentAllocationDataList[0]
        );
      }
    });

    let allowOverAllocation = lotAllocationData.some(
      ({ componentAllocationDetails }) => {
        const componentCode = componentAllocationDetails?.componentCode;
        return materialsData[componentCode]?.overAllocationDone === true;
      }
    );

    let allowUnderAllocation = lotAllocationData.some(
      ({ componentAllocationDetails }) => {
        const componentCode = componentAllocationDetails?.componentCode;
        return materialsData[componentCode]?.underAllocationDone === true;
      }
    );

    // // Create Final Payload Object
    let savePayload = {
      schrockenSLID: schrockenSLID,
      lastUpdatedBy: "",
      senderLegalName: "",
      receiverLegalName: "",
      dateChangeFlag: false,
      cdmoOrgID: vendorMosymphonyID,
      // allowOverAllocation: allowOverAllocation,
      overAllocationDone: allowOverAllocation,
      underAllocationDone: allowUnderAllocation,
      poNumber: poData?.scheduleAgreementNumber,
      poStatus: poData?.scheduleLineStatusText,
      productCodeDiscription: `${poData?.fgMaterialCode} / ${poData?.fgMaterialName}`,
      bomQty: poData?.targetQuantity,
      uom: poData?.targetQuantityUOM,
      boProductCode: lotAllocationRes?.boProductCode,
      boProductDescription: lotAllocationRes?.boProductDescription,
      cmoProductCode: lotAllocationRes?.cmoProductCode,
      cmoProductDescription: lotAllocationRes?.cmoProductDescription,
      componentAllocationDataList: componentAllocationDataList,
    };

    // console.log(savePayload);
    // savePayload = {};
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait....",
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`,
        savePayload
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });

          handleClose("success");
        } else {
          handleClose("failed");
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        handleClose("failed");
        dispatch({
          type: DESTROY_BACKDROP,
        });
      })
      .finally(() => {
        onClose();
      });
  };

  const handleSaveButtonEnable = () => {
    if (AllocationRef.current) {
      if (AllocationRef.current.validateForm()) {
        // setInputErrors({});
        // setTotalAllocationError("");
        // setErrorInfo("");
        const payload = AllocationRef.current.getPayload();
        // const useStatesOfMaterial = AllocationRef.current.states();

        // let obj = {
        //   ...materialsData,
        //   [selectedMaterial]: {
        //     ...payload,
        //   },
        // };
        setMaterialsData((prev)=>{
          return {
          ...prev,
          [selectedMaterial]: {
            ...payload,
          },
        }
        });
        const useStatesOfMaterial = AllocationRef.current.states();
        setMaterailStates((prev) => {
          return {
            ...prev,
            [selectedMaterial]: {
              // ...payload,
              states: useStatesOfMaterial,
            },
          };
        });
        // setMaterialsData((prev) => {
        //   return {
        //     ...prev,
        //     [selectedMaterial]: {
        //       ...payload,
        //       states: useStatesOfMaterial,
        //     },
        //   };
        // });
      } else {
        //         let obj = {
        //   ...materailStates,
        //   [selectedMaterial]: {
        //     // ...payload,
        //     states: useStatesOfMaterial,
        //   },
        // };
        // console.log(obj)
        const useStatesOfMaterial = AllocationRef.current.states();
        setMaterailStates((prev) => {
          return {
            ...prev,
            [selectedMaterial]: {
              // ...payload,
              states: useStatesOfMaterial,
            },
          };
        });
        if(isSaveEnabled){
        setIsSaveEnabled(false);
        }
      }
    }
  };

  //   const handleSaveStates = () =>{
  // const useStatesOfMaterial = AllocationRef.current.states();

  //         let obj = {
  //           ...materailStates,
  //           [selectedMaterial]: {
  //             // ...payload,
  //             states: useStatesOfMaterial,
  //           },
  //         };
  //         console.log(obj)
  //         setMaterailStates(obj);
  //   }

  return (
    <React.Fragment
      style={{
        overflow: "auto",
      }}
    >
      {!isClosing && <BackDropLoading />}
      <DialogContent>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              onClose();
              setIsClosing(true);
              // requestAnimationFrame(() => {
              //   onClose();
              // });
            }}
          >
            Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            fontWeight: "700",
            color: "black",
            fontSize: "22px",
            marginBottom: "0.5rem",
            marginLeft: "1rem",
            marginRight: "1rem",
            textAlign: "center",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1000,
            padding: "0.5rem",
          }}
        >
          Edit Material Planned Allocated Qty. for PO{" "}
          {poData?.scheduleAgreementNumber}
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#f2f8fb",
            border: "1px solid #ccc",
            borderRadius: "4px",
            // padding: "3px",
          }}
        >
          <Table
            className={classes.tablepadding}
            style={{ backgroundColor: "#f2f8fb" }}
          >
            <TableHead>
              <TableRow style={{ maxHeight: "2rem" }}>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    {localStorage.collabType === "CMO" ? "Sponsor" : "CMO"}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Plant ID
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Storage Location ID
                  </Typography>
                </TableCell>
                {/* <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    BMS Material Code / Description
                  </Typography>
                </TableCell> */}
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Material BOM Qty.
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>UOM</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow
                style={{
                  backgroundColor: "#f2f8fb",
                  border: "none",
                  maxHeight: "2rem",
                }}
              >
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {localStorage.collabType === "CMO"
                      ? poData?.sponsorName
                      : poData?.vendorName}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {presentFormatedData(poData?.vendorPlant)}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}
                  >
                    {presentFormatedData(poData?.storageLocation)}
                  </Typography>
                </TableCell>
                {/* <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}
                  >
                    {presentFormatedData(
                      selectedLotData?.componentAllocationDetails?.componentCode
                    )}
                    /
                    {presentFormatedData(
                      selectedLotData?.componentAllocationDetails?.componentName
                    )}
                  </Typography>
                </TableCell> */}
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {selectedLotData?.componentAllocationDetails
                      ?.componentQuantity !== undefined ||
                    selectedLotData?.componentAllocationDetails
                      ?.componentQuantity !== null
                      ? Number(
                          selectedLotData?.componentAllocationDetails
                            ?.componentQuantity
                        ).toFixed(3)
                      : "NA"}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {selectedLotData?.componentAllocationDetails?.uom}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: "16px",
            marginTop: "16px",
            marginBottom: "16px",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              border: "2px solid #ccc",
              borderRadius: 0,
              padding: "8px 24px",
              display: "flex",
              alignItems: "center",
              height: "auto",
              backgroundColor: "#fff",
              flex: 1,
              minWidth: "300px",
            }}
          >
            {lotAllocationData?.length > 0 &&
              lotAllocationData.map((component, index) => (
                <FormControlLabel
                  key={`${index}-${component?.componentAllocationDetails?.componentCode}`}
                  control={
                    <Radio
                      checked={
                        component?.componentAllocationDetails?.componentCode ===
                        selectedMaterial
                      }
                      onChange={(e) => {
                        if (AllocationRef.current) {
                          if (AllocationRef.current.validateForm()) {
                            setSelectedLotData(component);
                            setSelectedMaterial(
                              component?.componentAllocationDetails
                                ?.componentCode
                            );
                          }
                          const useStatesOfMaterial =
                            AllocationRef.current.states();

                          let obj = {
                            ...materailStates,
                            [selectedMaterial]: {
                              // ...payload,
                              states: useStatesOfMaterial,
                            },
                          };
                          console.log(obj);
                          setMaterailStates(obj);
                        }
                      }}
                      classes={{ checked: classes.customCheckbox }}
                    />
                  }
                  label={
                    <span style={{ fontSize: "13px" }}>
                      <div>
                        {presentFormatedData(
                          component?.componentAllocationDetails?.componentCode,
                          "NA"
                        )}{" "}
                        {"/"}
                      </div>
                      <div>
                        {presentFormatedData(
                          component?.componentAllocationDetails?.componentName,
                          "NA"
                        )}
                      </div>
                    </span>
                  }
                />
              ))}
          </Box>
        </Box>

        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
                opacity: 0.7,
                transition: "opacity 0.3s ease-in-out",
              }}
            >
              <Typography variant="body2">Loading...</Typography>
            </Box>
          }
        >
          <Box
            sx={{
              transition: "opacity 0.3s ease-in-out",
            }}
          >
            <AllocationQuantityForConsumption
              key={selectedLotData?.componentAllocationDetails?.componentCode}
              ref={AllocationRef}
              lotData={selectedLotData}
              onClose={onClose}
              poData={poData}
              schrockenSLID={schrockenSLID}
              vendorMosymphonyID={vendorMosymphonyID}
              handleClose={handleClose}
              lotAllocationData={lotAllocationData}
              lotAllocationRes={lotAllocationRes}
              previousData={materialsData}
              handleSaveButtonEnable={handleSaveButtonEnable}
              // handleSaveStates={handleSaveStates}
              materailStates={materailStates}
            />
          </Box>
        </Suspense>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "center", // Centers the button
          // paddingBottom: "16px", // Adds spacing at bottom
          marginBottom: "16px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={!isSaveEnabled}
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
          }}
          onClick={handleSave}
        >
          Save changes
        </Button>
      </DialogActions>

      <div
        style={{
          margin: "1rem",
          padding: "0.5rem",
          backgroundColor: "#f9f9f9",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          fontSize: "0.875rem",
        }}
      >
        <Typography
          variant="caption"
          style={{ fontSize: "0.875rem", marginRight: "8px" }}
        >
          Legend:
        </Typography>
        <FlagIcon
          style={{
            color: "yellow",
            fontSize: 20,
            stroke: "black",
            strokeWidth: 1.5,
            marginRight: "8px",
          }}
        />
        <Typography variant="caption" style={{ fontSize: "0.875rem" }}>
          Material near expiry
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default EditPlannedAllocatedQuantityDialog;
